<div class="center">
  <h1>Error 404</h1>
</div>
